import { takeLatest, put, call } from 'redux-saga/effects';

import { fetchUserProjects } from '../actions/fetchUserProjects';
import { fetchUserProjectDetails, fetchUserProjectDetailsFailure, fetchUserProjectDetailsSuccess } from '../slices/userProjectDetailsSlice';

function* getUserProjectDetails(action:any):Generator<any, void, string> {
  try {
    const { tenantId, objectId } = action.payload;
    // Call the fetchUserProjects API function with the tenantId and objectId
    const projectDetails:any = yield call(fetchUserProjects, tenantId, objectId); 
    // Dispatch the fetchUserProjectDetailsSuccess action with the response data
    yield put(fetchUserProjectDetailsSuccess(projectDetails));
  } catch (error:any) {
    // If there is an error, dispatch the fetchUserProjectDetailsFailure action with the error message
    yield put(fetchUserProjectDetailsFailure(error.message));
  }
}

// Watcher saga
function* userProjectDetailsSaga() {
  // Listen for the fetchUserProjectDetails action and call the getUserProjectDetails saga when dispatched
  yield takeLatest(fetchUserProjectDetails.type, getUserProjectDetails);
}

export default userProjectDetailsSaga;